// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_oi-8";
export var editMode = "_oi-3";
export var headerRow = "_oi-a";
export var headerTitle = "_oi-b";
export var product = "_oi-1";
export var productDetails = "_oi-5";
export var productDivider = "_oi-7";
export var productImage = "_oi-2";
export var productInfo = "_oi-4";
export var productTitle = "_oi-6";
export var strikethrough = "_oi-9";
export var upsellProductsCard = "_oi-0";